window.addEventListener('quick-view-global-event', () => {
  const selectQuickViewModal = document.querySelector('#modal-quickview-cart');
  const allSwatchesQuickView = selectQuickViewModal.querySelectorAll('.swatches__form--label');
  const sizeSwatchesContainerQuickView = selectQuickViewModal.querySelector('.js-size-options');
  let isSoldOutQuickView = selectQuickViewModal.querySelector('.price--sold-out');

  allSwatchesQuickView.forEach((sw) => {
    sw.addEventListener('click', function () {
      if (this.closest('.js-size-options')) return;

      setTimeout(() => {
        isSoldOutQuickView = selectQuickViewModal.querySelector('.price--sold-out');
        if (sizeSwatchesContainerQuickView && isSoldOutQuickView) {
          selectAvailableSizeQuickview(sizeSwatchesContainerQuickView);
        }
      });
    });
  });
});

function selectAvailableSizeQuickview(swatchContainer) {
  if (!swatchContainer) return;

  let breakFlag = true;
  const sizeSwatches = swatchContainer.querySelectorAll('.swatch-element');

  sizeSwatches.forEach((element) => {
    if (!element.classList.contains('soldout') && breakFlag) {
      breakFlag = false;
      element.querySelector('label').click();
    }
  });
}

